import styled, { createGlobalStyle } from 'styled-components';
import { media } from '@minecraft.themes';

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${(props): string => props.theme.colors.primary.white};
  color: ${(props): string => props.theme.colors.primary.darkGrey};
  padding-top: 3.1875rem;

  ${media.md`
    padding-top: 0;
  `}
`;

export const Inner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const AppGlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 16px;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    padding: 0;
    margin: 0;
    font-size: 1rem;
    line-height: 2;
  }
  a {
    text-decoration: none;
    color: ${(props): string => (props.theme as any).colors.primary.black};
  }
`;
